import PatPoints from "../../football/enums/pat-points";
import FirstDownStyles from "../../football/enums/first-down-styles";
import ClockType from "../../football/enums/clock-type";
import FieldLength from "../../football/enums/field-length";
import FieldAreaType from "../../football/enums/field-area-type";
import ParticipationStyle from "../../football/enums/participation-style";

const DefaultFlagFootballConfig = Object.freeze({
    general: Object.freeze({
        periodsInRegulation: 4,
        downs: 4,
        fieldLength: FieldLength.OptionFive.code,
        fieldWidth: 40,
        minutesByPeriod: 12,
        firstDownYards: 10, //traditional
        firstDownYardSet: [20, 40, 60, 80], //flag
        // When true, the crew has hand-edited firstDownYardSet, so startGame()
        // must preserve it instead of recomputing uniform zones from fieldLength.
        customFirstDownYardSet: false,
        firstDownFlagStyle: FirstDownStyles.ZoneToGain.code,
        timeoutsPerHalf: 3,
        redZoneLength: 10,
        zoneLength: 20,
        endZoneLength: 10,
        rushType: false,
        passType: false,
        spikeTeamAttOnly: false,
        touchdownsCountAsFirstDowns: false,
        teamLossOnly: [],
        teamZoneQty: 2,
        // Persisted field regions (yard coordinates within 0..fieldLength),
        // configured per event via the Field Areas marker editor. Only redZone
        // entries affect stats (via redZoneLength); the rest are display
        // metadata. Empty by default so it stays valid at any field length; the
        // editor seeds a layout (see UI). See [[field-config-markers]].
        fieldAreaSet: [
            { start: 0, end: 10, type: FieldAreaType.RedZone.code },
            { start: 70, end: 80, type: FieldAreaType.RedZone.code }
        ],
        participationStyle: ParticipationStyle.Default.code
    }),
    clock: Object.freeze({
        clockType: ClockType.DESC.code,
        runningClock: false
    }),
    spots: Object.freeze({
        kickoff: 35,
        driveStartingYardline: 14,
        touchbackYardline: 14,
        overtimeStartingYardline: 10,
        safetyYardline: 14,
        spotsPatScoreOption1: 3,
        spotsPatScoreOption2: 10,
        spotsPatScoreOption3: 20
    }),
    scoring: Object.freeze({
        touchdown: 6,
        safety: 2,
        rougePoints: 1,
        fieldGoal: 3,
        scoringPatScoreOption1: PatPoints.OptionOne.value,
        scoringPatScoreOption2: PatPoints.OptionTwo.value,
        scoringPatScoreOption3: PatPoints.OptionThree.value,
        playSummary: true
    })
});

export default DefaultFlagFootballConfig;
